document.addEventListener('DOMContentLoaded', function() {
  upcartOnCartUpdated = () => {
    fetch('?section_id=header-update-oncartevents')
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const headerUpdateOnCartEvents = doc.querySelector('#shopify-section-header-update-oncartevents');
        const headerUpdateOnCartEventsContainer = document.querySelector('#header-update-oncartevents');
        headerUpdateOnCartEventsContainer.innerHTML = headerUpdateOnCartEvents.innerHTML;
      });
    };
});